import { down } from 'styled-breakpoints'
import styled, { css } from 'styled-components'

export const Content = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: 15px;
  justify-content: space-between;
  flex-direction: row;
  ${down('md')} {
    flex-direction: column;
  }
`
